/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Input_Position_Box_TitleInputs */

const en_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Position: ${i?.position}`)
};

const fr_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Position : ${i?.position}`)
};

const de_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Position: ${i?.position}`)
};

const it_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posizione: ${i?.position}`)
};

const ru_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Должность: ${i?.position}`)
};

const es_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posición: ${i?.position}`)
};

const zh_cn2_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`位置：${i?.position}`)
};

const ja_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ポジション: ${i?.position}`)
};

const hi_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`स्थिति: ${i?.position}`)
};

const pt_pt2_input_position_box_title = /** @type {(inputs: Input_Position_Box_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Posição: ${i?.position}`)
};

/**
* | output |
* | --- |
* | "Position: {position}" |
*
* @param {Input_Position_Box_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_box_title = /** @type {((inputs: Input_Position_Box_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Box_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_box_title(inputs)
	if (locale === "de") return de_input_position_box_title(inputs)
	if (locale === "it") return it_input_position_box_title(inputs)
	if (locale === "ru") return ru_input_position_box_title(inputs)
	if (locale === "es") return es_input_position_box_title(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_box_title(inputs)
	if (locale === "ja") return ja_input_position_box_title(inputs)
	if (locale === "hi") return hi_input_position_box_title(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_box_title(inputs)
	return en_input_position_box_title(inputs)
});